import { render, staticRenderFns } from "./ListTraceabilityCompleted.vue?vue&type=template&id=bc6fd7a2&"
import script from "./ListTraceabilityCompleted.vue?vue&type=script&lang=js&"
export * from "./ListTraceabilityCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports